import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface SelectedFiltersProps {
    selectedFilters: { selectedOpts: string[]; filterBy?: string }[];
    cancelFilter: (filter: { opt: string; filterBy: string }) => void;
    staticDataTabIndex: number | undefined;
}

const SelectedFilters = (props: SelectedFiltersProps) => {
    const { selectedFilters, cancelFilter, staticDataTabIndex } = props;

    return (
        <>
            {selectedFilters
                .filter((sf) => sf?.selectedOpts?.length > 0)
                ?.map((filter: any) => (
                    <div key={filter.label} className="selected-filters">
                        <label className="filter-by" tabIndex={staticDataTabIndex || 0}>
                            {filter?.label ? (
                                <div className="dropdown-label">{filter.label}</div>
                            ) : (
                                filter?.filterBy
                            )}
                        </label>
                        <div className="options">
                            {filter?.selectedOpts?.map((opt: string) => (
                                <div key={opt} className="option">
                                    <span tabIndex={staticDataTabIndex || 0}>{opt}</span>
                                    <FontAwesomeIcon
                                        tabIndex={0}
                                        focusable={true}
                                        className={'icon-cancel'}
                                        icon={faTimes}
                                        onClick={() =>
                                            cancelFilter({ opt, filterBy: filter?.filterBy })
                                        }
                                        onKeyDown={(e) =>
                                            e.key === 'Enter' &&
                                            cancelFilter({ opt, filterBy: filter?.filterBy })
                                        }
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
        </>
    );
};

export default SelectedFilters;
